module.exports = __webpack_public_path__ + "static/media/graham-success.46e901f4.png";